import type React from 'react';

import { FeaturedVictories } from './components/FeaturedVictories';
import { VictoriesBody } from './components/VictoriesBody';
import { VictoryHighlight } from './components/VictoryHighlight';

export const VictoriesImpact: React.FC = () => {
	return (
		<>
			<VictoriesBody />
			<VictoryHighlight />
			<FeaturedVictories />
		</>
	);
};
